<template>
    <div class="container-pieChart_v_m">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/pie'



import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'pieChart_v_m',
  props: {  
    title:{
      type: String,
      default: ""
    },
    num:{
       type: Number,
       default: 100
    }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
        grid: {
            top:'0',          
            bottom: '0',
            containLabel: true
        },
       title: {
              zlevel: 0,
              text: this.num+"%",
              textStyle:{
                color:'#fff',
                fontSize:14
              },
              x: 'center',//文字位置
              y:'center'//文字位置
          },
        series: [
            {
            
                type: 'pie',
                radius: ['60%', '80%'], 
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
              
                labelLine: {
                    show: false
                },
                data: [
                    {value: this.num, name: '数值',itemStyle:{color:'#6648FF'}},
                    {value: 100-this.num, name: '剩余',itemStyle:{color:'#000000'}},
              
                ]
            }
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-pieChart_v_m{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>